import { render } from "./ListEgreso.vue?vue&type=template&id=2771d577"
import script from "./ListEgreso.vue?vue&type=script&lang=js"
export * from "./ListEgreso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__